module.exports = __webpack_public_path__ + "static/img/main.649c7de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv006/main.jpg
// module id = C4FU
// module chunks = 0